import {
  APIComponentAttributes,
  APIComponentType,
  APIEntityType,
  APIFieldAttributes,
  APIModelAttributes,
  APIReferenceAttributes,
  APIReferenceType,
  APITagAttributes,
} from '@ardoq/api-types';
import type { EnhancedScopeData } from '@ardoq/data-model';

export const getEntitiesByIds = <T extends APIEntityType>(
  entityType: T,
  entityIDs: string[],
  enhancedScopeData: EnhancedScopeData
): (GetEntityByIdReturnType<T> | undefined)[] =>
  entityIDs.map(id => getEntityById(entityType, id, enhancedScopeData));

export const getEntityById = <T extends APIEntityType>(
  entityType: T,
  entityId: string,
  enhancedScopeData: EnhancedScopeData,
  parentEntityId?: string
): GetEntityByIdReturnType<T> | undefined => {
  let entity;
  if (entityType === APIEntityType.COMPONENT_TYPE) {
    entity =
      enhancedScopeData.typesByModelId[parentEntityId!]?.componentTypesById[
        entityId
      ];
  } else if (entityType === APIEntityType.REFERENCE_TYPE) {
    entity =
      enhancedScopeData.typesByModelId[parentEntityId!]?.referenceTypesById[
        entityId
      ];
  } else if (entityType === APIEntityType.COMPONENT)
    entity = enhancedScopeData.componentsById[entityId];
  else if (entityType === APIEntityType.REFERENCE)
    entity = enhancedScopeData.referencesById[entityId];
  else if (entityType === APIEntityType.FIELD)
    entity = enhancedScopeData.fieldsById[entityId];
  else if (entityType === APIEntityType.TAG)
    entity = enhancedScopeData.tagsById[entityId];
  else if (entityType === APIEntityType.MODEL)
    entity = enhancedScopeData.modelsById[entityId];
  return entity as GetEntityByIdReturnType<T> | undefined;
};
export type GetEntityByIdReturnType<T> = T extends APIEntityType.FIELD
  ? APIFieldAttributes
  : T extends APIEntityType.COMPONENT
    ? APIComponentAttributes
    : T extends APIEntityType.REFERENCE
      ? APIReferenceAttributes
      : T extends APIEntityType.COMPONENT_TYPE
        ? APIComponentType
        : T extends APIEntityType.REFERENCE_TYPE
          ? APIReferenceType
          : T extends APIEntityType.TAG
            ? APITagAttributes
            : T extends APIEntityType.MODEL
              ? APIModelAttributes
              : undefined;
